import { render, staticRenderFns } from "./aboutCompany.vue?vue&type=template&id=d50a7596&"
import script from "./aboutCompany.vue?vue&type=script&lang=js&"
export * from "./aboutCompany.vue?vue&type=script&lang=js&"
import style0 from "./aboutCompany.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports